import { Select, FormControl, FormLabel } from "@chakra-ui/react";
import { Field } from "react-final-form";

const SelectField = ({
  id,
  label,
  choices,
  placeholder,
  labelPlacement,
  isRequired,
}) => {
  return (
    <Field
      name={`id_${id}`}
      validate={(values) => {
        if (isRequired && !values) {
          return "Required";
        }
      }}
    >
      {({ input, meta }) => (
        <FormControl isInvalid={meta.error && meta.touched}>
          {labelPlacement !== "HIDDEN" && <FormLabel>{label}</FormLabel>}
          <Select placeholder={placeholder} bg="white" {...input}>
            {choices.map(({ text, value }, key) => (
              <option value={value} key={key}>
                {text}
              </option>
            ))}
          </Select>
        </FormControl>
      )}
    </Field>
  );
};

export default SelectField;
